import { useTranslation } from "@repo/translation";
import { parseIsoDate } from "@repo/utils";
import { type Locale, isSameDay } from "date-fns";

import { localizeDate } from "./LocalizedDate";
import { localizeDateAndTime } from "./LocalizedDateAndTime";
import { localizeTime } from "./LocalizedTime";

interface Props {
  fromDate?: string | Date;
  toDate?: string | Date;
  dateFnsLocale?: Locale;
  timezone?: string;
}

export const LocalizedDateTimeRange = ({
  fromDate,
  toDate,
  timezone,
}: Props) => {
  const { dateFnsLocale } = useTranslation();
  return (
    <>{localizeDateTimeRange(fromDate, toDate, dateFnsLocale, timezone)}</>
  );
};

export const localizeDateTimeRange = (
  fromDate?: string | Date,
  toDate?: string | Date,
  dateFnsLocale?: Locale,
  timezone?: string
) => {
  const left = parseIsoDate(fromDate);
  const right = parseIsoDate(toDate);

  if (left && right) {
    // Same day => Show date and time
    if (isSameDay(left, right)) {
      const formattedFromTime = localizeTime(left, dateFnsLocale, timezone);
      const formattedToTime = localizeTime(right, dateFnsLocale, timezone);

      return `${localizeDate(
        fromDate ?? "",
        dateFnsLocale,
        timezone
      )}, ${formattedFromTime} - ${formattedToTime}`;
    }
    return `${localizeDateAndTime(
      fromDate!,
      dateFnsLocale,
      timezone
    )} - ${localizeDateAndTime(toDate ?? "", dateFnsLocale, timezone)}`;
  }
  return localizeDateAndTime(fromDate || toDate || "", dateFnsLocale, timezone);
};
